import React from 'react';
import { Input, Control, ErrorComponent, Link } from 'MWComponents';
import '../less';
import joinToOffer_img from '../img/cards.png';
import joinToOffer_img_2024 from '../img/cards_2024.png';
import joinToOffer_img_2024_2 from '../img/cards_2024_2.png';
import Checkbox from 'MWComponents/dest/components/Checkbox';
import success_img from '../img/success_img.png';

export default function template() {
    const model = this.getModel(),
      imgSrcData = {
      '2023': joinToOffer_img,
        '2024': joinToOffer_img_2024,
        '2024_2': joinToOffer_img_2024_2
      },
        { contactPhoneNumber, passwordOTP } = model.fields,
        { isMobile, card, year } = this.props,
        form =
          (<React.Fragment>
              <img className="order-img" alt="order_green_card"
                   src={imgSrcData[year]}></img>
              <div className="left-side">
                <div className="left-side">
                  <div className="card-order">
                    <div className="order-wrapper green-card">
                      <Control>
                        <Input
                          {...this.bindProps('phone')}
                          name="contactPhoneNumber"
                          value={contactPhoneNumber.value}
                          onChange={this.handleChange}
                          onBlur={() => this.onBlurHandle('contactPhoneNumber')}
                          label={this.l10n('OKKO_PROMO_INPUT_LABEL')}
                          format={model._phoneFormat}
                          stringify={model._phoneFormat}
                          defaultValue="UA +38 (0"
                          placeholder="+380 (XX) XXX XX XX"
                          floating={false}
                          className={`w-wide ${contactPhoneNumber.errors.length &&
                          !contactPhoneNumber.firstInput ? 'err-field' : ''}`}
                        />
                        <div className={`error-message ${contactPhoneNumber.errors.length && !contactPhoneNumber.firstInput
                          ? 'active'
                          : ''
                          }`}
                        >
                          <div>{this.l10n(contactPhoneNumber.errors.join('.'))}</div>
                        </div>
                      </Control>
                    </div>
                    <div className="button-wrapper">
                      <button className="button button-order"
                              onClick={this.sendForm}
                              disabled={!model.canSubmit}>
                        {this.l10n('OKKO_PROMO_GET_MESSAGE')}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

            </React.Fragment>
        ),
        success = (
            <React.Fragment>
                  <img src={success_img} alt="success_img" className='success-img' />
                  <div className="success-title">{this.l10n('CARDS_ORDER_RESULT_HEADING')}</div>
                  <div className="success-subtitle">{this.l10n('CARDS_ORDER_RESULT_DESC')}</div>
            </React.Fragment>
        ),
        error = (
            <Control className="control" style={{ marginTop: '30px' }}>
                <ErrorComponent type="form">
                    {this.l10n('GREEN_CARD_ORDER_ERROR_TEXT')}
                </ErrorComponent>
            </Control>
        ),

        screens = {
            form,
            success,
            error
        };
    this.state.productName = card;

    return (
            <div className={`form-container card-order-wrapper ${card} ${this.state.activeScreen}`}>
                {screens[this.state.activeScreen]}
            </div>
    )
}
